export default __webpack_public_path__ + "static/media/jeet.48ea916d.png";